import { Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArticleThumbnailContent from '../../components/blog/ArticleThumbnailContent';
import ArticleThumbnail from '../../components/blog/ArticleThumbnail';
import { formatDate } from '../../utils';
import { useMediaQueries } from '../../contexts/media-query';

interface Props {
  image: { url: string };
  title: string;
  content: string;
  author: string;
  type: string;
  date: string;
  tags: string;
  created_at: string;
  thumbnailSnippet: string;
  slug: string;
}

interface Blog {
  blog: Props;
  loading: boolean;
}

const fontFamily = 'var(--fontBase)';

function BlogListing({ blog, loading }: Blog) {
  const { image, title, content, author, created_at, tags, thumbnailSnippet, slug } = blog;
  const { isLessThan640, isLessThan899 } = useMediaQueries();
  const thumbnailWidth = isLessThan899 && !isLessThan640 ? '70%' : 'auto';

  const navigate = useNavigate();

  const handleNavigation = (endpoint: string) => {
    navigate(endpoint);
  };
  return (<>
  { loading ? <></> : (
    <div
      className="rounded-lg overflow-hidden cursor-pointer flex flex-col items-center"
      style={{ height: 'fit-content', marginBottom: isLessThan640 ? '12px' : '16px' }}
      onClick={() => handleNavigation(slug)}
      >
      <ArticleThumbnail ratio='1/0.5' image={image} title={title} width={thumbnailWidth} />
      <div className="py-2" style={{ paddingTop: isLessThan640 ? '8px' : '12px' }}>
        <ArticleThumbnailContent 
          title={title} 
          tags={tags} 
          thumbnailSnippet={thumbnailSnippet} 
          className="mt-1"
          isMobile={isLessThan640}
          isTablet={isLessThan899}
        />
        <div className="flex gap-4 items-center text-xs mt-1">
          <Typography
            variant="h6"
            style={{
              fontFamily,
              fontSize: '12px',
            }}>
            <strong>{author}</strong>
          </Typography>
          <Typography
            variant="h6"
            style={{
              fontFamily,
              fontSize: '12px',
            }}>
            <strong>{formatDate(created_at)}</strong>
          </Typography>
        </div>
      </div>
    </div>)}
  </>
  );
}

export default BlogListing;
